import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { environment } from '../environments/default/environment';

const routerOptions: ExtraOptions = {
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'enabled',
};

const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/register/register.component').then((m) => m.RegisterComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
  },
  {
    path: 'pin-entry',
    loadComponent: () => import('./pages/pin/pin-entry.component').then((m) => m.PinEntryComponent),
  },
  {
    path: 'invalid-link',
    loadComponent: () => import('./pages/invalid-link/invalid-link.component').then((m) => m.InvalidLinkComponent),
  },

  {
    path: 'submission-status',
    loadComponent: () => import('./pages/submission-status/submission-status.component').then((m) => m.SubmissionStatusComponent),
  },

  // Staging demo build only (environment.enableDemo). Must stay above ':guid', which matches any single segment.
  {
    path: 'demo/results',
    canMatch: [() => environment.enableDemo === true],
    loadComponent: () => import('./pages/demo/demo-results.component').then((m) => m.DemoResultsComponent),
  },

  {
    path: ':guid',
    loadComponent: () => import('./pages/landing/landing.component').then((m) => m.LandingComponent),
  },

  {
    path: 'app',
    children: [
      {
        path: 'patient-form',
        loadComponent: () => import('./pages/patient-info/patient-info.component').then((m) => m.PatientInfoComponent),
      },

      {
        path: '',
        redirectTo: 'patient-form',
        pathMatch: 'full',
      },
    ],
  },

  { path: '**', redirectTo: '/login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
